import { gql } from '@apollo/client'
import { activeDraftFragment } from '~/graphql/fragments/activeDraft'

export const GET_ACTIVE_DRAFT = gql`
  query getActiveDraft {
    loggedInUser {
      id
      activeDraft {
        ...activeDraft
      }
    }
  }

  ${activeDraftFragment}
`
